import React from "react";
import s from './index.module.css';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

export default function Header({ onSearch }) { // 获取搜索功能的回调
  const { Search } = Input;
  return (
    <>
      <div className={s.header}>
        <div className={s.top}>
          <div className={s.content}>
            <div className={s.logo}>
              <a href="https://www.biaoxq.com/">
                <img src="/assets/images/logo.png" alt="logo" />
              </a>
            </div>
            <div className={s.search}>
              <Search
                prefix={<SearchOutlined style={{ color: '#ccc', fontSize: 20 }} className="site-form-item-icon" />}
                placeholder="请输入关键词"
                allowClear
                enterButton="搜索"
                size="large"
                onSearch={onSearch} // 当用户搜索时，触发onSearch回调
              />
            </div>
            <div className={s.qr}>
              <div>
                <p>扫一扫关注</p>
                <img src="/assets/images/QRcode1.png" alt="二维码" />
              </div>
              <div>
                <p>微信扫一扫</p>
                <img src="/assets/images/QRcode2.jpg" alt="二维码" />
              </div>
            </div>
          </div>
        </div>
        <div className={s.menu}>
          <div className={s.m}>
            <ul>
              <li>
                <a href="https://www.biaoxq.com/">
                  <span>
                    首页
                  </span>
                </a>
              </li>
              <li className={s.menuon}>
                <a href="https://www.biaoxq.com/cgzh">
                  <span>
                    技术转让
                  </span>
                </a>
              </li>
              <li>
                <a href="https://www.biaoxq.com/mall/">
                  <span>
                    品牌交易
                  </span>
                </a>
              </li>
              <li>
                <a href="https://www.biaoxq.com/service/">
                  <span>
                    品牌服务
                  </span>
                </a>
              </li>
              <li>
                <a href="https://www.biaoxq.com/news/">
                  <span>
                    环球视角
                  </span>
                </a>
              </li>
              <li>
                <a href="https://www.biaoxq.com/video/">
                  <span>
                    视频培训
                  </span>
                </a>
              </li>
              <li>
                <a href="https://www.biaoxq.com/brand/">
                  <span>
                    环球品牌
                  </span>
                </a>
              </li>
              <li>
                <a href="https://www.biaoxq.com/empower/">
                  <span>
                    品牌授权
                  </span>
                </a>
              </li>
              <li>
                <a href="https://www.biaoxq.com/know/">
                  <span>
                    品牌问答
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
